// GA4 Event Tracking Utilities for DumaExpertBéton
// Measurement ID: G-WH62GF14CR

const isDev = process.env.NODE_ENV === 'development';

function fireEvent(eventName, params) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
    if (isDev) console.log(`[GA4] ${eventName}`, params);
  } else if (isDev) {
    console.warn(`[GA4] gtag not available for: ${eventName}`);
  }
}

// 1. Click telephone — any click on tel: link
export const trackClickTelephone = () => {
  fireEvent('click_telephone', {
    event_category: 'contact',
    event_label: 'phone_click',
    value: 1
  });
};

// 2. Generate lead — form submitted successfully (devis, contact, rdv)
export const trackGenerateLead = (source = 'devis_submit') => {
  fireEvent('generate_lead', {
    event_category: 'conversion',
    event_label: source,
    value: 1
  });
};

// 3. Click WhatsApp — any click on wa.me link
export const trackClickWhatsapp = () => {
  fireEvent('click_whatsapp', {
    event_category: 'contact',
    event_label: 'whatsapp_click',
    value: 1
  });
};

// 4. Calculator used — when price calculator shows result
export const trackCalculatorUsed = () => {
  fireEvent('calculator_used', {
    event_category: 'engagement',
    event_label: 'price_calculator',
    value: 1
  });
};

// Global listener for tel: and wa.me links (call once on app mount)
export function initLinkTracking() {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:')) {
      trackClickTelephone();
    } else if (href.includes('wa.me') || href.includes('whatsapp')) {
      trackClickWhatsapp();
    }
  });
  if (isDev) console.log('[GA4] Link tracking initialized (tel: + wa.me)');
}
